import script from "./NumStatistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumStatistics.vue?vue&type=script&lang=ts&setup=true"

import "./NumStatistics.vue?vue&type=style&index=0&id=4dd5201f&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd5201f"]])

export default __exports__